import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const starRatingDefaultVariants = {
  "variant": "default"
}
const starRatingCompoundVariants = []

const starRatingSlotNames = [
  [
    "root",
    "StarRating__root"
  ],
  [
    "current",
    "StarRating__current"
  ],
  [
    "filled",
    "StarRating__filled"
  ],
  [
    "halfFilled",
    "StarRating__halfFilled"
  ],
  [
    "outlined",
    "StarRating__outlined"
  ]
]
const starRatingSlotFns = /* @__PURE__ */ starRatingSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, starRatingDefaultVariants, getSlotCompoundVariant(starRatingCompoundVariants, slotName))])

const starRatingFn = memo((props = {}) => {
  return Object.fromEntries(starRatingSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const starRatingVariantKeys = [
  "isActive",
  "variant"
]
const getVariantProps = (variants) => ({ ...starRatingDefaultVariants, ...compact(variants) })

export const starRating = /* @__PURE__ */ Object.assign(starRatingFn, {
  __recipe__: false,
  __name__: 'starRating',
  raw: (props) => props,
  variantKeys: starRatingVariantKeys,
  variantMap: {
  "isActive": [
    "true"
  ],
  "variant": [
    "default",
    "ghost"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, starRatingVariantKeys)
  },
  getVariantProps
})